exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".B60cEJJTcl09PH_b6XJaj ::-webkit-input-placeholder {\n  font-style: italic;\n}\n.B60cEJJTcl09PH_b6XJaj :-moz-placeholder {\n  font-style: italic;\n}\n.B60cEJJTcl09PH_b6XJaj ::-moz-placeholder {\n  font-style: italic;\n}\n.B60cEJJTcl09PH_b6XJaj :-ms-input-placeholder {\n  font-style: italic;\n}\n", ""]);
// Exports
exports.locals = {
	"input-tag-list": "B60cEJJTcl09PH_b6XJaj"
};